import { SvgIconType } from './svg.interface';

const People: SvgIconType = ({
  width = 16,
  height = 16,
  className = '',
  color = 'white'
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2.4 3.2C1.52 3.2 0.8 3.92 0.8 4.8C0.8 5.68 1.52 6.4 2.4 6.4C3.28 6.4 4 5.688 4 4.8C4 3.912 3.288 3.2 2.4 3.2ZM8 1.6C7.68355 1.6 7.37421 1.69384 7.11109 1.86965C6.84797 2.04546 6.64289 2.29534 6.52179 2.58771C6.40069 2.88007 6.36901 3.20177 6.43074 3.51214C6.49248 3.82251 6.64487 4.10761 6.86863 4.33137C7.09239 4.55513 7.37749 4.70752 7.68786 4.76926C7.99823 4.83099 8.31993 4.79931 8.61229 4.67821C8.90466 4.55711 9.15454 4.35203 9.33035 4.08891C9.50616 3.82579 9.6 3.51645 9.6 3.2C9.6 2.312 8.888 1.6 8 1.6ZM13.6 0C12.72 0 12 0.72 12 1.6C12 2.48 12.72 3.2 13.6 3.2C14.48 3.2 15.2 2.488 15.2 1.6C15.2 0.712 14.488 0 13.6 0ZM1.2 7.2C0.536 7.2 0 7.736 0 8.4V12H0.8V16H4V12H4.8V8.4C4.8 7.736 4.264 7.2 3.6 7.2H1.2ZM6.8 5.6C6.136 5.6 5.6 6.136 5.6 6.8V10.4H6.4V14.4H9.6V10.4H10.4V6.8C10.4 6.136 9.864 5.6 9.2 5.6H6.8ZM12.4 4C11.736 4 11.2 4.536 11.2 5.2V8.8H12V12.8H15.2V8.8H16V5.2C16 4.536 15.464 4 14.8 4H12.4Z"
      fill={color}
    />
  </svg>
);

export default People;
